import { useState, useEffect } from 'react';

interface AdminUser {
  id: string;
  email: string;
}

export const useAdminAuth = () => {
  const [adminUser, setAdminUser] = useState<AdminUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAdminAuth();
  }, []);

  const checkAdminAuth = () => {
    try {
      const sessionToken = localStorage.getItem('adminSession');
      const adminUserData = localStorage.getItem('adminUser');

      if (sessionToken && adminUserData) {
        // Decode and validate session token
        const decodedToken = JSON.parse(atob(sessionToken));
        const currentTime = Date.now();
        const tokenAge = currentTime - decodedToken.timestamp;
        
        // Token expires after 24 hours
        if (tokenAge < 24 * 60 * 60 * 1000) {
          setAdminUser(JSON.parse(adminUserData));
        } else {
          // Token expired, clear storage
          localStorage.removeItem('adminSession');
          localStorage.removeItem('adminUser');
        }
      }
    } catch (error) {
      console.error('Error checking admin auth:', error);
      localStorage.removeItem('adminSession');
      localStorage.removeItem('adminUser');
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('adminSession');
    localStorage.removeItem('adminUser');
    setAdminUser(null);
  };

  const isAuthenticated = !!adminUser;

  return {
    adminUser,
    loading,
    isAuthenticated,
    logout,
    checkAdminAuth
  };
};